module.exports = "<div class=product-grid ng-class=\"{'product-grid-related': vm.mode === 'related'}\" ng-if=!vm.errorOccurred> <div class=r ng-class=\"{'r-md-3-col r-lg-4-col r-xl-4-col r-xx-5-col': vm.mode === 'overview'}\"> <rent-product-overview-grid-item class=c ng-repeat=\"product in vm.products | orderBy:vm.orderByProperty:vm.isOrderByDescending\" product=product> </rent-product-overview-grid-item> </div> </div> <div ng-if=vm.errorOccurred translate>Product overview cannot be shown</div>";


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rent-product-overview-grid.html
// module id = 645
// module chunks = 0